import * as identityActions from './identity.actions';
import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { of } from 'rxjs';
import { exhaustMap, map } from 'rxjs/operators';

@Injectable()
export class IdentityEffects {
  public getUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(identityActions.fetchIdentityAction),
      exhaustMap(() =>
        of(this.msalService.instance.getAllAccounts()[0]).pipe(
          map(account => identityActions.fetchIdentitySucceededAction({ account }))
        )
      )
    )
  );

  constructor(private actions$: Actions, private msalService: MsalService) {}
}
